import { ValueOf } from '@vy/utils';

export const RENEW_CONTRACT_TERMS_STEPS = Object.freeze({
  Details: 0,
}) satisfies Record<string, number>;

export type RenewContractTermsStep = ValueOf<typeof RENEW_CONTRACT_TERMS_STEPS>;
